import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './utils';

export const discountApis = createApi({
    reducerPath: 'discountApis',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Discount'],
    endpoints: (builder) => ({
        getDiscountList: builder.query({
            query: ({ page }) => `discountList?page=${page}`,
            providesTags: ['Discount'],
        }),
        addNewDiscount: builder.mutation({
            query: (body) => {
                return { url: `createDiscount`, body, method: "POST" }
            },
            invalidatesTags: ['Discount'],
        }),
        updateDiscount: builder.mutation({
            query: (body) => {
                const { id, formData } = body;
                return { url: `updateDiscount/${id}`, body: formData, method: "PUT" }
            },
            invalidatesTags: ['Discount'],
        }),
        deleteDiscount: builder.mutation({
            query: (id) => {
                return { url: `deleteDiscount/${id}`, method: "DELETE" }
            },
            invalidatesTags: ['Discount'],
        }),
        statusChangeDiscount: builder.mutation({
            query: (body) => {
                const { id, status } = body;
                return { url: `statusChangeDiscount/${id}`, method: "PUT", body: { status } }
            },
            invalidatesTags: ['Discount'],
        }),
    }),
})

export const { useGetDiscountListQuery, useAddNewDiscountMutation, useDeleteDiscountMutation, useUpdateDiscountMutation, useStatusChangeDiscountMutation } = discountApis
